import { Controller } from '@hotwired/stimulus';
import * as bootstrap from 'bootstrap';

// Initializes Bootstrap ScrollSpy on the document body,
// targeting the nav element this controller is attached to.
//
// Usage:
//   <nav data-controller="scrollspy-nav">
//     <a href="#section1">Section 1</a>
//   </nav>
export default class extends Controller {
  connect() {
    this.scrollspy = new bootstrap.ScrollSpy(document.body, {
      target: this.element,
      offset: this.element.offsetHeight + 20,
      smoothScroll: true,
    });
  }

  disconnect() {
    this.scrollspy?.dispose();
  }
}
